import React from 'react';
import { contacts, content } from '../content';
import { ArrowRightIcon, QuoteIcon } from './Icon';
import '../styles/QuoteBar.css';

const { quote } = content;

const QuoteBar = () => (
  <section className="quote">
    <QuoteIcon size={34} className="quote__mark" />
    <blockquote className="quote__text">
      {quote.text.map((line, index) => (
        <React.Fragment key={line}>
          {index > 0 && <br />}
          {line}
        </React.Fragment>
      ))}
    </blockquote>
    {/* Telegram, not mailto: on a phone a mail client is a dead end, and this
        audience answers in a messenger anyway. */}
    <a
      className="quote__cta"
      href={contacts.telegram}
      target="_blank"
      rel="noreferrer"
    >
      {quote.cta}
      <ArrowRightIcon size={16} />
    </a>
  </section>
);

export default QuoteBar;
